export enum WasteTypes {
  GROSS_SOURCE_NAME = 'Brutto',
  NET_SOURCE_NAME = 'Netto',
  WASTE_SOURCE_NAME = 'Avfall %'
}